import "@/App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./context/CartContext";
import { Header } from "./components/site/Header";
import { Footer } from "./components/site/Footer";
import { CartDrawer } from "./components/site/CartDrawer";
import { SmoothScroll } from "./components/site/SmoothScroll";
import Home from "./pages/Home";
import OurStory from "./pages/OurStory";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Checkout from "./pages/Checkout";
import Wholesale from "./pages/Wholesale";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";

const NotFound = () => (
  <div className="mx-auto max-w-3xl px-5 pt-40 pb-32 text-center" data-testid="not-found-page">
    <h1 className="font-wide text-5xl uppercase">Lost the trail.</h1>
    <Link to="/" className="mt-6 inline-block font-cond uppercase tracking-widest text-dano-red underline">Back home</Link>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <SmoothScroll />
        <Header />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/our-story" element={<OurStory />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/:slug" element={<ProductDetail />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/wholesale" element={<Wholesale />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <CartDrawer />
        <Toaster position="bottom-center" />
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
